module.exports = __webpack_public_path__ + "img/wink.93231857.png";